<template>
  <v-stepper
    v-model="step"
    class="onboarding-stepper"
  >
    <v-stepper-header
      class="onboarding-stepper__stepper-header"
    >
      <v-stepper-step
        class="onboarding-stepper__stepper-step"
        :complete="step > 1"
        :step="1"
      />

      <v-divider class="onboarding-stepper__stepper-divider" />

      <v-stepper-step
        class="onboarding-stepper__stepper-step"
        :complete="step > 2"
        :step="2"
      />
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content
        :step="1"
      >
        <OnboardingStepperForm
          :step="1"
          :next-step="nextStep"
          :previous-step="previousStep"
        >
          <OnboardingUserAndCompany :onboarding-data="onboardingData" />
        </OnboardingStepperForm>
      </v-stepper-content>

      <v-stepper-content
        :step="2"
      >
        <OnboardingStepperForm
          :step="2"
          :next-step="nextStep"
          :previous-step="previousStep"
        >
          <OnboardingDashboardSelection :onboarding-data="onboardingData" />
        </onboardingstepperform>
      </v-stepper-content>
      <v-stepper-content
        :step="3"
      >
        <OnboardingStepperForm
          :step="3"
          :stepper-processing="stepperProcessing"
          concluded
        >
          <OnboardingEnd />
        </OnboardingStepperForm>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import OnboardingStepperForm from '@/components/onboarding/OnboardingStepperForm';
import OnboardingUserAndCompany from '@/components/onboarding/steps/OnboardingUserAndCompany';
import OnboardingDashboardSelection from '@/components/onboarding/steps/OnboardingDashboardSelection';
import OnboardingEnd from '@/components/onboarding/steps/OnboardingEnd';

import { trackEventWithUserProperties } from '@/utils/mixpanel';
import onboardingModel from '@/mixins/onboarding-model';

export default {
  name: 'OnboardingStepperSecondEditor',
  components: {
    OnboardingStepperForm,
    OnboardingUserAndCompany,
    OnboardingDashboardSelection,
    OnboardingEnd,
  },
  mixins: [
    onboardingModel,
  ],
  props: {
    onboardingData: {
      type: Object,
      required: true,
    },
    stepperProcessing: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      step: 1,
    };
  },
  computed: {
    stepsName() {
      return [
        this.$t('components.Onboarding.identifier.step.userAndCompany'),
        this.$t('components.Onboarding.identifier.step.dashboardSelection'),
      ];
    },
  },
  methods: {
    nextStep() {
      const trackData = { ...this.onboardingData,
        step: this.stepsName[this.step - 1],
        editorType: this.getEditorType(),
      };
      trackEventWithUserProperties('ST OnboardingWizard NextButton Click', trackData);
      this.step++;
    },
    previousStep() {
      trackEventWithUserProperties('ST OnboardingWizard PreviousButton Click', {
        step: this.stepsName[this.step - 1],
        editorType: this.getEditorType(),
      });
      this.step--;
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-stepper {
    border-radius: 0;
    overflow: hidden;
    position: relative;
    -webkit-box-shadow: none;
    box-shadow: none;
    background-color: transparent !important;
    width: inherit;
    padding-left: 85px;
    padding-right: 85px;
    flex-grow: 1;

    &__stepper-header {
      justify-content: left;
      -webkit-box-shadow: none;
      box-shadow: none;
    }

    &__stepper-step {
      padding: 0;
    }

    &__stepper-divider {
      max-width: 40px;
      margin: 0;
      border-color: var(--ds-color-silver);
    }
  }

  .theme--dark.v-stepper .v-stepper__header .v-divider {
    border-color: var(--ds-color-silver);
  }

  ::v-deep {
    .v-stepper__step__step {
      margin: 0;
    }

    .v-stepper__step--active {
      .v-stepper__step__step {
        background: var(--ds-color-neutral) !important;
        border: 2px solid var(--ds-color-primary);
      }
    }

    .v-stepper__step--inactive {
      .v-stepper__step__step {
        background: var(--ds-color-neutral) !important;
        border: 2px dashed var(--ds-color-silver);
      }
    }
  }

  .v-stepper__content {
    padding: 0;
  }
</style>
